import React, { useEffect, useState } from "react";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";
import { ImageLink } from "../constants";

const Setting = () => {
  const [settingData, setSettingData] = useState([]);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({
    title: "",
    description: "",
    websiteEmail: "",
    phoneNumber: "",
    mobileNumber: "",
    websiteAddress: "",
    websiteLogo: "",
    footerLogo: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`setting/getSettings`);
      const { data } = response.data;
      setSettingData(data);
      setData({ ...data });
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    }
  };

  const validateForm = () => {
    let newErrors = {};
    if (!data.title?.trim()) newErrors.title = "Website Title is required";
    if (!data.description?.trim()) newErrors.description = "Website Description is required";

    if (!data.phoneNumber?.trim()) {
      newErrors.phoneNumber = "Phone Number is required";
    } else if (!/^\+?\d{10,15}$/.test(data.phoneNumber.replace(/[\s-]/g, ''))) {
      newErrors.phoneNumber = "Invalid Phone Number. Must be 10-15 digits.";
    }

    if (!data.mobileNumber?.trim()) {
      newErrors.mobileNumber = "Mobile Number is required";
    } else if (!/^\+?\d{10,15}$/.test(data.mobileNumber.replace(/[\s-]/g, ''))) {
      newErrors.mobileNumber = "Invalid Mobile Number. Must be 10-15 digits.";
    }

    if (!data.websiteEmail?.trim()) {
      newErrors.websiteEmail = "Website Email is required";
    } else if (!/\S+@\S+\.\S+/.test(data.websiteEmail)) {
      newErrors.websiteEmail = "Invalid Email format";
    }

    if (!data.websiteAddress?.trim()) newErrors.websiteAddress = "Website Address is required";

    if (!data.websiteLogo && !settingData?.websiteLogo) {
      newErrors.websiteLogo = "Website Logo is required";
    }
    if (!data.footerLogo && !settingData?.footerLogo) {
      newErrors.footerLogo = "Footer Logo is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, files, value } = e.target;
    if (name === "websiteLogo" || name === "footerLogo") {
      setData({ ...data, [name]: files?.length > 0 ? files[0] : null });
    } else {
      setData({ ...data, [name]: value });
    }
    setErrors({ ...errors, [name]: "" });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    try {
      const formData = new FormData();
      if (data?.websiteLogo instanceof File) {
        formData.append("websiteLogo", data?.websiteLogo);
      }
      if (data?.footerLogo instanceof File) {
        formData.append("footerLogo", data?.footerLogo);
      }
      formData.append("title", data?.title);
      formData.append("description", data?.description)
      formData.append("phoneNumber", data?.phoneNumber);
      formData.append("mobileNumber", data?.mobileNumber);
      formData.append("websiteEmail", data?.websiteEmail);
      formData.append("websiteAddress", data?.websiteAddress);
      const response = await axiosInstance.put(
        `setting/updateSettings`,
        formData
      );
      if (response?.status === 200) {
        toast.success(response?.data?.message);
        fetchData();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5 mx-4">
          <h3 className="page-title">Website Settings </h3>
        </div>
        <div className="col-md-12 grid-margin stretch-card">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <form className="pt-3" onSubmit={handleUpdate}>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-form-label"
                        >
                          Website Title
                        </label>
                        <input
                          type="text"
                          className={`form-control form-control-sm ${errors.title ? "is-invalid" : ""}`}
                          id="title"
                          name="title"
                          placeholder="Enter a title"
                          value={data?.title || ""}
                          onChange={handleChange}
                        />
                        {errors.title && <span className="text-danger small">{errors.title}</span>}
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="form-group">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-form-label"
                        >
                          Website Description
                        </label>
                        <textarea
                          type="text"
                          className={`form-control form-control-sm ${errors.description ? "is-invalid" : ""}`}
                          id="description"
                          name="description"
                          placeholder="Enter a Description"
                          value={data?.description || ""}
                          onChange={handleChange}
                          rows={4}
                        />
                        {errors.description && <span className="text-danger small">{errors.description}</span>}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-form-label"
                        >
                          Phone Number
                        </label>
                        <input
                          type="text"
                          className={`form-control form-control-sm ${errors.phoneNumber ? "is-invalid" : ""}`}
                          id="phoneNumber"
                          name="phoneNumber"
                          placeholder="Enter a phone"
                          value={data?.phoneNumber || ""}
                          onChange={handleChange}
                        />
                        {errors.phoneNumber && <span className="text-danger small">{errors.phoneNumber}</span>}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-form-label"
                        >
                          Mobile Number
                        </label>
                        <input
                          type="text"
                          className={`form-control form-control-sm ${errors.mobileNumber ? "is-invalid" : ""}`}
                          id="mobileNumber"
                          name="mobileNumber"
                          placeholder="Enter a mobile"
                          value={data?.mobileNumber || ""}
                          onChange={handleChange}
                        />
                        {errors.mobileNumber && <span className="text-danger small">{errors.mobileNumber}</span>}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-form-label"
                        >
                          Website Email
                        </label>
                        <textarea
                          type="text"
                          className={`form-control form-control-sm ${errors.websiteEmail ? "is-invalid" : ""}`}
                          id="websiteEmail"
                          name="websiteEmail"
                          placeholder="Enter a email"
                          value={data?.websiteEmail || ""}
                          onChange={handleChange}
                        />
                        {errors.websiteEmail && <span className="text-danger small">{errors.websiteEmail}</span>}
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="form-group">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-form-label"
                        >
                          Website Address
                        </label>
                        <textarea
                          type="text"
                          className={`form-control form-control-sm ${errors.websiteAddress ? "is-invalid" : ""}`}
                          id="websiteAddress"
                          name="websiteAddress"
                          placeholder="Enter a address"
                          value={data?.websiteAddress || ""}
                          onChange={handleChange}
                        />
                        {errors.websiteAddress && <span className="text-danger small">{errors.websiteAddress}</span>}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-form-label"
                        >
                          Website Logo
                        </label>
                        <input
                          type="file"
                          className={`form-control form-control-sm ${errors.websiteLogo ? "is-invalid" : ""}`}
                          id="websiteLogo"
                          name="websiteLogo"
                          onChange={handleChange}
                        />
                        {errors.websiteLogo && <span className="text-danger small">{errors.websiteLogo}</span>}
                        <div className="mt-4">
                          {data?.websiteLogo instanceof File ? (
                            <img
                              src={URL.createObjectURL(data?.websiteLogo)}
                              alt="logo_preview"
                              height={200}
                              style={{ padding: "20px !important" }}
                            />
                          ) : (
                            <img
                              src={
                                settingData && settingData?.websiteLogo
                                  ? ImageLink(settingData?.websiteLogo)

                                  : ""
                              }
                              alt="logo_preview"
                              className={
                                settingData && settingData?.websiteLogo
                                  ? ""
                                  : "d-none"
                              }
                              height={200}
                              style={{ width: "400px " }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label
                          htmlFor="exampleInputUsername2"
                          className="col-form-label"
                        >
                          Footer Logo
                        </label>
                        <input
                          type="file"
                          className={`form-control form-control-sm ${errors.footerLogo ? "is-invalid" : ""}`}
                          id="footerLogo"
                          name="footerLogo"
                          onChange={handleChange}
                        />
                        {errors.footerLogo && <span className="text-danger small">{errors.footerLogo}</span>}
                        <div className="mt-4">
                          {data?.footerLogo instanceof File ? (
                            <img
                              className="footer-bg-logo"
                              src={URL.createObjectURL(data?.footerLogo)}
                              alt="logo_preview"
                              height={200}
                            />
                          ) : (
                            <img
                              src={
                                settingData && settingData?.footerLogo
                                  ? ImageLink(settingData?.footerLogo)
                                  : ""
                              }
                              alt="logo_preview"
                              className={
                                settingData && settingData?.footerLogo
                                  ? "footer-bg-logo"
                                  : "d-none"
                              }
                              height={200}
                              style={{ width: "400px " }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {settingData && settingData?.websiteLogo && <hr />}
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="text-start mt-4">
                        <button type="submit" className="btn btn-success">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Setting;
